import { ReactElement } from 'react';
import { MetaType } from '@lmp/eduki-routes';
import translation from '../../languages';
import DocumentMeta from '../document-meta/document-meta';

const MetaWrapper = ({ children, meta }: { children: ReactElement; meta: () => MetaType }) => {
   // @ts-ignore
   return <DocumentMeta {...(meta ? meta() : {})} >{children}</DocumentMeta>;
};

const translate = translation('meta');

export default translate(MetaWrapper);
